import { useState } from "react";
import { Check, Copy, Loader2, Wand2 } from "lucide-react";

const plain = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  return JSON.stringify(value, null, 2);
};

const fieldClass = "w-full rounded-md bg-white/5 border border-white/10 px-4 py-3 text-sm text-white placeholder:text-zinc-400 focus:outline-none focus:border-white/30 transition-colors duration-300";

export const AssetCard = ({ title, value, testid, copied, onCopy, asset, onRefine, refining }) => {
  const [open, setOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const busy = refining === asset;

  const submit = async () => {
    if (feedback.trim().length < 3 || busy) return;
    await onRefine(asset, feedback.trim());
    setFeedback("");
    setOpen(false);
  };

  return (
    <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-6 relative" data-testid={testid}>
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="font-display text-xl text-white">{title}</h3>
        <div className="flex items-center gap-2 shrink-0">
          {asset && onRefine && (
            <button type="button" onClick={() => setOpen(!open)} data-testid={`refine-${testid}`}
              className="flex items-center gap-1.5 text-xs text-zinc-400 hover:text-white border border-white/10 rounded-full px-3 py-1.5 transition-colors duration-300">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={1.5} /> : <Wand2 className="w-3.5 h-3.5" strokeWidth={1.5} />}
              {busy ? "Refining…" : "Refine"}
            </button>
          )}
          <button type="button" onClick={() => onCopy(testid, value)} data-testid={`copy-${testid}`}
            className="flex items-center gap-1.5 text-xs text-zinc-400 hover:text-white border border-white/10 rounded-full px-3 py-1.5 transition-colors duration-300">
            {copied === testid ? <Check className="w-3.5 h-3.5 text-emerald-400" strokeWidth={2} /> : <Copy className="w-3.5 h-3.5" strokeWidth={1.5} />}
            {copied === testid ? "Copied" : "Copy"}
          </button>
        </div>
      </div>
      <p className="text-sm text-zinc-300 leading-relaxed whitespace-pre-wrap">{plain(value) || "Not generated for this campaign."}</p>
      {open && (
        <div className="mt-5 pt-5 border-t border-white/10" data-testid={`refine-box-${testid}`}>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={2}
            placeholder='Tell Wingman what to change — e.g. "Shorter, lead with the outcome"'
            data-testid={`refine-input-${testid}`}
            className={`${fieldClass} resize-none`}
          />
          <div className="flex items-center gap-2 mt-3">
            <button type="button" onClick={submit} disabled={busy || feedback.trim().length < 3} data-testid={`refine-submit-${testid}`}
              className="h-9 px-4 rounded-full v4-btn-primary text-xs font-semibold flex items-center gap-2 disabled:opacity-40 transition-colors duration-300">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={1.5} /> : <Wand2 className="w-3.5 h-3.5" strokeWidth={1.5} />}
              {busy ? "Refining…" : "Apply refinement"}
            </button>
            <button type="button" onClick={() => setOpen(false)} data-testid={`refine-cancel-${testid}`}
              className="h-9 px-4 rounded-full border border-white/15 text-white text-xs font-medium hover:bg-white/10 transition-colors duration-300">
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
